import { render } from "./AddDemoModal.vue?vue&type=template&id=30405c9a&scoped=true"
import script from "./AddDemoModal.vue?vue&type=script&lang=js"
export * from "./AddDemoModal.vue?vue&type=script&lang=js"

import "./AddDemoModal.vue?vue&type=style&index=0&id=30405c9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30405c9a"]])

export default __exports__